import { Routes, Route } from 'react-router-dom'
import Catalog from './pages/Catalog'
import Favorites from './pages/Favorites'
import AdminPanel from './components/AdminPanel'
import { workers } from './data/workers'

export default function App() {
  return (
    <div style={{ maxWidth: 480, margin: '0 auto', backgroundColor: '#ffffff', minHeight: '100vh', boxShadow: '0 0 40px rgba(0,0,0,0.25)' }}>
      <Routes>
        <Route path="/" element={<Catalog />} />
        <Route path="/favorites" element={<Favorites />} />
        <Route path="/admin" element={<AdminPanel initialWorkers={workers} />} />
      </Routes>
    </div>
  )
}
